"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return genRollupSelectv2;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
const _relationmanager = require("~/db/relation-manager");
const _models = require("~/models");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _conditionV2 = require("~/db/conditionV2");
const _profiler = require("~/helpers/profiler");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function genRollupSelectv2(param) {
    const { baseModelSqlv2, knex, alias, columnOptions, nestedLevel = 0 } = param;
    let { parentColumns } = param;
    const context = baseModelSqlv2.context;
    parentColumns = parentColumns != null ? parentColumns : _nocodbsdk.CircularRefContext.make();
    const profiler = _profiler.Profiler.start('DEBUG:/genRollupSelectv2/' + columnOptions.fk_column_id);
    const column = await _models.Column.get(context, {
        colId: columnOptions.fk_column_id
    });
    if (column) {
        const model = await _models.Model.getByAliasOrId(context, {
            base_id: context.base_id,
            aliasOrId: column.fk_model_id
        });
        parentColumns = parentColumns.cloneAndAdd({
            id: column.id,
            title: column.title,
            table: model == null ? void 0 : model.title
        });
    }
    profiler.log('cloneAndAdd done');
    let relationColumn;
    if (!columnOptions.getRelationColumn) {
        relationColumn = await _models.Column.get(context, {
            colId: columnOptions.fk_relation_column_id
        });
    } else {
        relationColumn = await columnOptions.getRelationColumn(context);
    }
    profiler.log('getRelationColumn done');
    const relationColumnOption = await relationColumn.getColOptions(context);
    const { parentContext, childContext, mmContext, refContext } = await relationColumnOption.getParentChildContext(context);
    const isMMLike = (0, _nocodbsdk.isMMOrMMLike)(relationColumn);
    const rollupColumn = columnOptions.getRollupColumn ? await columnOptions.getRollupColumn(refContext) : await _models.Column.get(refContext, {
        colId: columnOptions.fk_rollup_column_id
    });
    profiler.log('get relation (parent/child) columns');
    if (!rollupColumn) {
        _ncError.NcError.get(context).fieldNotFound(columnOptions.fk_rollup_column_id);
    }
    const childCol = await relationColumnOption.getChildColumn(childContext);
    const childModel = await (childCol == null ? void 0 : childCol.getModel(childContext));
    const parentCol = await relationColumnOption.getParentColumn(parentContext);
    const parentModel = await (parentCol == null ? void 0 : parentCol.getModel(parentContext));
    const refTableAlias = `__nc_rollup_` + Math.random().toString(36).substring(2, 8);
    profiler.log('get base model');
    const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
        model: parentModel,
        dbDriver: knex
    });
    const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
        model: childModel,
        dbDriver: knex
    });
    const refBaseModel = rollupColumn.fk_model_id === childModel.id ? childBaseModel : parentBaseModel;
    const applyFunction = async (qb)=>{
        profiler.log('applyFunction ' + rollupColumn.uidt);
        let selectColumnName = knex.raw('??.??', [
            refTableAlias,
            rollupColumn.column_name
        ]);
        if (rollupColumn.uidt === _nocodbsdk.UITypes.Formula) {
            const formulOption = await rollupColumn.getColOptions(context);
            const formulaQb = await (0, _formulaQueryBuilderv2.default)({
                baseModel: _relationmanager.RelationManager.isRelationReversed(relationColumn, relationColumnOption) ? parentBaseModel : childBaseModel,
                tree: formulOption.formula,
                model: _relationmanager.RelationManager.isRelationReversed(relationColumn, relationColumnOption) ? parentModel : childModel,
                column: rollupColumn,
                aliasToColumn: {},
                tableAlias: refTableAlias,
                validateFormula: false,
                parsedTree: formulOption.getParsedTree(),
                baseUsers: undefined,
                parentColumns
            });
            selectColumnName = knex.raw(formulaQb.builder).wrap('(', ')');
        } else if ([
            _nocodbsdk.UITypes.Rollup
        ].includes(rollupColumn.uidt)) {
            const knex = refBaseModel.dbDriver;
            // Rollup-of-rollup: compute inner rollup correlated to the current level
            const inner = await genRollupSelectv2({
                baseModelSqlv2: refBaseModel,
                knex,
                alias: refTableAlias,
                columnOptions: await rollupColumn.getColOptions(refContext),
                nestedLevel: nestedLevel + 1,
                parentColumns
            });
            // Use the inner builder directly as a subquery
            selectColumnName = knex.raw('(?)', [
                inner.builder
            ]);
        } else if ([
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.CreatedBy,
            _nocodbsdk.UITypes.LastModifiedTime,
            _nocodbsdk.UITypes.LastModifiedBy
        ].includes(rollupColumn.uidt)) {
            // since all field are virtual field,
            // we use formula to generate query that can represent the column
            // to prevent duplicate logic
            const formulaQb = await (0, _formulaQueryBuilderv2.default)({
                baseModel: _relationmanager.RelationManager.isRelationReversed(relationColumn, relationColumnOption) ? parentBaseModel : childBaseModel,
                tree: '{{' + rollupColumn.id + '}}',
                model: _relationmanager.RelationManager.isRelationReversed(relationColumn, relationColumnOption) ? parentModel : childModel,
                column: rollupColumn,
                tableAlias: refTableAlias,
                parsedTree: {
                    type: 'Identifier',
                    name: rollupColumn.id,
                    raw: '{{' + rollupColumn.id + '}}',
                    dataType: [
                        _nocodbsdk.UITypes.CreatedTime,
                        _nocodbsdk.UITypes.LastModifiedTime
                    ].includes(rollupColumn.uidt) ? 'date' : 'string'
                }
            });
            selectColumnName = knex.raw(formulaQb.builder).wrap('(', ')');
        }
        // if postgres and rollup function is sum/sumDistinct/avgDistinct/avg, then cast the column to integer when type is boolean
        if (baseModelSqlv2.isPg && [
            'sum',
            'sumDistinct',
            'avgDistinct',
            'avg'
        ].includes(columnOptions.rollup_function) && [
            'bool',
            'boolean'
        ].includes(rollupColumn.dt)) {
            var _qb_columnOptions_rollup_function;
            (_qb_columnOptions_rollup_function = qb[columnOptions.rollup_function]) == null ? void 0 : _qb_columnOptions_rollup_function.call(qb, knex.raw('??::integer', [
                selectColumnName
            ]));
            profiler.log('applyFunction done');
            return;
        }
        if ([
            'sum',
            'sumDistinct',
            'avgDistinct',
            'avg'
        ].includes(columnOptions.rollup_function)) {
            var _knex_columnOptions_rollup_function;
            qb.select(knex.raw(`COALESCE((??), 0)`, [
                (_knex_columnOptions_rollup_function = knex[columnOptions.rollup_function]) == null ? void 0 : _knex_columnOptions_rollup_function.call(knex, selectColumnName)
            ]));
        } else {
            var _qb_columnOptions_rollup_function1;
            (_qb_columnOptions_rollup_function1 = qb[columnOptions.rollup_function]) == null ? void 0 : _qb_columnOptions_rollup_function1.call(qb, selectColumnName);
        }
        profiler.log('applyFunction done');
    };
    const relationType = isMMLike ? _nocodbsdk.RelationTypes.MANY_TO_MANY : relationColumnOption.type;
    switch(relationType){
        case _nocodbsdk.RelationTypes.HAS_MANY:
            {
                profiler.log('Relation: ' + relationColumnOption.type);
                const queryBuilder = knex(knex.raw(`?? as ??`, [
                    childBaseModel.getTnPath(childModel),
                    refTableAlias
                ])).where(knex.ref(`${alias || parentBaseModel.getTnPath(parentModel.table_name)}.${parentCol.column_name}`), '=', knex.ref(`${refTableAlias}.${childCol.column_name}`));
                await applyFunction(queryBuilder);
                if (column) {
                    await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                        qb: queryBuilder,
                        column,
                        alias: refTableAlias,
                        table: childBaseModel.model,
                        baseModel: childBaseModel,
                        context: childBaseModel.context
                    });
                }
                profiler.end();
                return {
                    builder: queryBuilder
                };
            }
        case _nocodbsdk.RelationTypes.ONE_TO_ONE:
            {
                profiler.log('Relation: ' + relationColumnOption.type);
                const qb = knex(knex.raw(`?? as ??`, [
                    childBaseModel.getTnPath(childModel == null ? void 0 : childModel.table_name),
                    refTableAlias
                ])).where(knex.ref(`${alias || parentBaseModel.getTnPath(parentModel.table_name)}.${parentCol.column_name}`), '=', knex.ref(`${refTableAlias}.${childCol.column_name}`));
                await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                    qb,
                    column,
                    alias: refTableAlias,
                    table: childBaseModel.model,
                    baseModel: childBaseModel,
                    context: childBaseModel.context
                });
                await applyFunction(qb);
                profiler.end();
                return {
                    builder: qb
                };
            }
        case _nocodbsdk.RelationTypes.MANY_TO_MANY:
            {
                profiler.log('Relation: ' + relationColumnOption.type);
                const mmModel = await relationColumnOption.getMMModel(mmContext);
                const mmChildCol = await relationColumnOption.getMMChildColumn(mmContext);
                const mmParentCol = await relationColumnOption.getMMParentColumn(mmContext);
                const assocBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                    id: mmModel.id,
                    dbDriver: knex
                });
                if (!mmModel) {
                    return this.dbDriver.raw(`?`, [
                        _nocodbsdk.NcDataErrorCodes.NC_ERR_MM_MODEL_NOT_FOUND
                    ]);
                }
                const qb = knex(knex.raw(`?? as ??`, [
                    parentBaseModel.getTnPath(parentModel == null ? void 0 : parentModel.table_name),
                    refTableAlias
                ])).innerJoin(assocBaseModel.getTnPath(mmModel.table_name), knex.ref(`${assocBaseModel.getTnPath(mmModel.table_name)}.${mmParentCol.column_name}`), '=', knex.ref(`${refTableAlias}.${parentCol.column_name}`)).where(knex.ref(`${assocBaseModel.getTnPath(mmModel.table_name)}.${mmChildCol.column_name}`), '=', knex.ref(`${alias || childBaseModel.getTnPath(childModel.table_name)}.${childCol.column_name}`));
                await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                    qb: qb,
                    column,
                    alias: refTableAlias,
                    table: parentBaseModel.model,
                    baseModel: parentBaseModel,
                    context: parentBaseModel.context
                });
                await applyFunction(qb);
                profiler.end();
                return {
                    builder: qb
                };
            }
        default:
            _ncError.NcError.get(context).unSupportedRelation(relationColumnOption.type);
    }
}
